import React, { PropsWithChildren } from 'react';
import bem from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';

export enum StrongModifier {
  FONT_COLOR_RED = 'font-color-red',
}

type Strong = {
  modifier?: Modifier<StrongModifier>;
};

export function Strong(props: PropsWithChildren<Strong>) {
  return <strong className={bem('strong', props.modifier)}>{props.children}</strong>;
}
